/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

/**
 * create builds a new form; update edits currentForm.
 */
export type AiGenerateRequestMode = typeof AiGenerateRequestMode[keyof typeof AiGenerateRequestMode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AiGenerateRequestMode = {
  create: 'create',
  update: 'update',
} as const;
